import { LayoutModule } from '@angular/cdk/layout';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { EditCompanyInvoiceCardComponent } from './profile/edit-company-invoice-card/edit-company-invoice-card.component';
import { EditCompanyProfileCardComponent } from './profile/edit-company-profile-card/edit-company-profile-card.component';
import { EditPasswordCardComponent } from './profile/edit-password-card/edit-password-card.component';
import { ProfileComponent } from './profile/profile.component';
import { StoreListComponent } from './store/list/list.component';
import { SharedCommonModule } from '../common/sharedCommon.module'
import { RouterModule } from '@angular/router';
import { SubscriptionComponent } from './subscription/subscription.component';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { CreateCompanyInstructionsComponent } from './ui/create-company-instructions/create-company-instructions.component';
import { SidebarTileComponent } from './ui/sidebar-tile/sidebar-tile.component';
import { CompanySelectComponent } from './ui/company-select/company-select.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LanguageButtonComponent } from './ui/language-button/language-button.component';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ShopPackageItemComponent } from './store/components/shop-package-item/shop-package-item.component';
import { CarouselModule } from 'primeng/carousel';
import { SelectButtonModule } from 'primeng/selectbutton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InvoiceFormDialogComponent } from './store/components/invoice-form-dialog/invoice-form-dialog.component';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ChipModule } from 'primeng/chip';
import { PackagesProfileListComponent } from './profile/packages-list/packages-profile-list.component';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { EkoGenericTableComponent } from '@ekowitryna/ui';
import { TabsModule } from 'primeng/tabs';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { TableModule } from 'primeng/table';
import { SkeletonModule } from 'primeng/skeleton';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {
  EkoLayoutAppBarComponent,
  EkoLayoutSidebarComponent,
  EkoNavigationMenuComponent,
  EkoScrollToTopComponent,
} from '@ekowitryna/ui';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        DashboardComponent,
        ProfileComponent,
        StoreListComponent,
        EditCompanyProfileCardComponent,
        EditPasswordCardComponent,
        EditCompanyInvoiceCardComponent,
        SubscriptionComponent,
        CreateCompanyInstructionsComponent,
        SidebarTileComponent,
        CompanySelectComponent,
        ShopPackageItemComponent,
        InvoiceFormDialogComponent,
        PackagesProfileListComponent
    ],
    imports: [
        CommonModule,
        LayoutModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        InputTextModule,
        PasswordModule,
        ConfirmDialogModule,
        ToastModule,
        GoogleTagManagerModule,
        SelectModule,
        CheckboxModule,
        TableModule,
        SkeletonModule,
        MessageModule,
        ProgressSpinnerModule,
        CarouselModule,
        RadioButtonModule,
        SelectButtonModule,
        DynamicDialogModule,
        ConfirmPopupModule,
        FontAwesomeModule,
        ChipModule,
        ToggleSwitchModule,
        TabsModule,
        TooltipModule,
        TranslateModule,
        SharedCommonModule,
        // Ekowitryna UI
        EkoGenericTableComponent,
        EkoLayoutAppBarComponent,
        EkoLayoutSidebarComponent,
        EkoNavigationMenuComponent,
        EkoScrollToTopComponent,
        LanguageButtonComponent
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())],
    exports: []
})
export class DashboardModule { }
